type Props = {
  title: string;
  description?: string;
};

const SessionInstructions: React.FC<Props> = ({ title, description }) => (
  <div data-testid="session-instructions" className="space-y-[8px]">
    <div
      className="font-inter font-medium text-[16px] leading-[24px] text-[#16150E]"
      data-testid="session-instructions-title"
    >
      {title}
    </div>
    {description && (
      <p
        className="font-inter font-normal text-[14px] leading-[20px] text-[#67665F]"
        data-testid="session-instructions-description"
      >
        {description}
      </p>
    )}
  </div>
);

export default SessionInstructions;
